module.exports = __webpack_public_path__ + "img/3.827e429e.png";